<template>    
<div class="hg-input-group">
    <input  :type="inputType" 
            :value="value" 
            :id="id"
            class="hg-input"
            @input="$emit('input', $event.target.value)" 
            @focus="$emit('focus', $event)"
            @blur="$emit('blur', $event)"
            @change="$emit('change', $event)"
            @keypress="$emit('keypress', $event)"
            @keydown="$emit('keydown', $event)"
            @keyup="$emit('keyup', $event)"
            :disabled="disabled"
            :readonly="readonly"
            :required="required"
    />
    <a class="hg-input-group btn" @click="(inputType=='password')?(inputType='text'):(inputType='password')" title="Show/Hide password">
        <font-awesome-icon :icon="(inputType == 'password')?('eye'):('eye-slash')" />
    </a>
</div>
</template>
<script>
export default {
    props: {
        id:         {type: String},
        value:      {type: String},
        disabled:   {type: Boolean},
        readonly:   {type: Boolean},
        required:   {type: Boolean}
    },
    data(){
        return {
            inputType: "password"
        }
    }    
}
</script>
<style scoped>
.hg-input-group{ 
    /* border: 1px solid #eee; border-radius:1; */
    display:inline-flex; 
    flex-direction: row;
    padding:0;
}
.hg-input-group input{ border: 0; background:#FFFFFF; width: 100%; padding-top:0; padding-bottom:0; margin:0;height:100%;}
.hg-input-group input:focus {outline-width: 0;}
.hg-input-group a{transition: opacity ease-in-out 200ms; background:transparent; color: #333; padding-top:12px; padding-right:10px; height:100%; cursor:pointer;opacity:0.5}
.hg-input-group a:hover{opacity:1}
.hg-input-group.hg-error a{color:#FFFFFF;}
</style>
